export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/ibs`;
export const SERVER_BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
// export const API_BASE_URL = "http://localhost:3003";
// export const SERVER_BASE_URL = "http://localhost:3000";
//export const PDF_URL='https://ibirds-enterprise--dev.sandbox.my.salesforce-sites.com/hrms/servlet/servlet.FileDownload?file='
export const PDF_URL='https://java-velocity-9670.my.salesforce-sites.com/portalIBhrms/servlet/servlet.FileDownload?file='
export const Company_Name = 'iBirds Software Services Pvt. Ltd.'
export const College_Name = 'Star Infotech College'